import { Paths } from "@/core/constants/paths";
import type { PageHeaderTabItem } from "@/ds";

export const CONTROL_PANEL_TITLE = "Painel de Controle";

export const CONTROL_PANEL_TABS_LABEL = "Abas do Painel de Controle";

/** Mobile: as abas viram um seletor ao lado do título, em vez de rolar na horizontal (P-21). */
export const CONTROL_PANEL_MOBILE_QUERY = "(max-width: 768px)";

/**
 * Abas do Painel de Controle. O acesso é decidido pela API (claims `hub.auditoria:view`,
 * `hub.perfil:view`, `hub.permissao:view` e `hub.usuario:view`), então todas ficam visíveis e cada aba trata o 403.
 */
export const CONTROL_PANEL_TABS: readonly PageHeaderTabItem[] = [
  { label: "Usuários", to: Paths.CONTROL_PANEL_USERS },
  { label: "Perfis", to: Paths.CONTROL_PANEL_ROLES },
  { label: "Permissões", to: Paths.CONTROL_PANEL_PERMISSIONS },
  { label: "Auditoria", to: Paths.CONTROL_PANEL_AUDIT },
];
